import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { FiArrowLeft, FiArrowRight } from "react-icons/fi";
import { useSwipeable } from "react-swipeable";
import useMobile from "../../../../hooks/useMobile";
import { motion } from "framer-motion";
import { buttonAnimated } from "../../../../Variables";
import { campaigns } from "../../../../data/Data";


export const PrevAndNextCampaign = () => {
    const [prevSlug, setPrevSlug] = useState(null);
    const [nextSlug, setNextSlug] = useState(null);

    const isMobile = useMobile();

    const { slug } = useParams();

    useEffect(() => {
        const campaignsFilter = campaigns?.filter(item => item.status === true);
        
        const currentIndex = campaignsFilter?.findIndex(campaigns => campaigns.slug === slug);
        
        if (currentIndex > 0) {
            setPrevSlug(campaignsFilter[currentIndex - 1].slug);
        } else {
            setPrevSlug(null);
        }

        if (currentIndex < campaignsFilter?.length - 1) {
            setNextSlug(campaignsFilter[currentIndex + 1].slug);
        } else {
            setNextSlug(null);
        }
    }, [slug]);
    
    const navigate = useNavigate();

    const handlePrevSlug = () => {
        if (prevSlug) {
            navigate(`/${"campagnes"}/${prevSlug}`);
        }
    }

    const handleNextSlug = () => {
        if (nextSlug) {
            navigate(`/${"campagnes"}/${nextSlug}`);
        }
    }

    const swipeHandlers = useSwipeable({
        onSwipedLeft: () => {
            if (isMobile && nextSlug) {
                handleNextSlug();
            }
        },
        onSwipedRight: () => {
            if (isMobile && prevSlug) {
                handlePrevSlug();
            }
        },
        preventDefaultTouchmoveEvent: true,
        trackMouse: false
    });

    const stylebutton = "rounded-full h-14 w-14 bg-slate-200 flex items-center justify-center"

    return (
        <>
            <div {...swipeHandlers} className="absolute w-full h-screen" />
            <ul className="absolute flex h-screen justify-between items-center w-full pointer-events-none">
                <li className={isMobile ? 'hidden' : 'block'}>
                    <motion.button 
                        onClick={handlePrevSlug}
                        whileHover={buttonAnimated.whileHover} 
                        whileTap={buttonAnimated.whileHover}
                        disabled={!prevSlug}
                        className={`${stylebutton} ${!prevSlug ? 'opacity-50 cursor-not-allowed' : 'hover:bg-gray-100'} pointer-events-auto`}
                    >
                        <FiArrowLeft />
                    </motion.button>
                </li>
                <li className={isMobile ? 'hidden' : 'block'}>
                    <motion.button 
                        onClick={handleNextSlug}
                        whileHover={buttonAnimated.whileHover} 
                        whileTap={buttonAnimated.whileHover}

                        transition={{ type:"spring", stiffness:200, damping:50, ease:"easeIn"}}
                        disabled={!nextSlug}
                        className={`${stylebutton} ${!nextSlug ? 'opacity-50 cursor-not-allowed' : 'hover:bg-gray-100'} pointer-events-auto`}
                    >
                        <FiArrowRight />
                    </motion.button>
                </li>
            </ul>
        </>
    );
}